var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BasePopup', {
    attrs: {
      "show": _vm.show,
      "show-close-button": false,
      "close-on-overlay": false
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "confirm-popup-content"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.description ? _c('div', {
    staticClass: "popup-description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _c('div', {
    staticClass: "confirm-buttons"
  }, [_c('button', {
    staticClass: "confirm-btn confirm-btn--cancel",
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]), _c('button', {
    staticClass: "confirm-btn confirm-btn--confirm",
    on: {
      "click": function click($event) {
        return _vm.$emit('confirm');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmText) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }